import { useState, useEffect } from 'react';
import { ReactDataContext } from '@themost/react';
import 'styles/css/IIAform.css';
import Loader from 'react-loader-spinner';


const MobilityAgreementApprovalResponse = ({ iia, userService }) => {
    const [approvals, setApprovals] = useState([]);
    const [fetched, setFetched] = useState(false);

    const context = new ReactDataContext(process.env.REACT_APP_API_SERVER);
    context.setBearerAuthorization(userService.getToken());

    useEffect(() => {
        (async () => {
            try {
                let result = context.model(`MobilityAgreementApprovalResponses`).asQueryable().where('iiaId').equal(new String(iia.id));
                if (iia?.partnerAgreementIdentifications.length > 0) {
                    for (let i = 0; i < iia?.partnerAgreementIdentifications.length; i++) {
                        result = result.or('iiaId').equal(new String(iia?.partnerAgreementIdentifications[i]?.iiaId));
                    }
                }
                result = await result.getItems();

                setFetched(true)
                setApprovals(result)
            } catch (error) {
                console.log(error)
            }
        })()
    }, []);


    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <h3 className="text-center">Approval Responses</h3>
                </div>
            </div>
            {
                (approvals.length !== 0)
                    ?
                    <div id="no-more-tables">
                        <table className="table-striped table-condensed cf table-responsive">
                            <thead className="cf" style={{ backgroundColor: "#3A435E", color: "white" }}>
                                <tr>
                                    <th scope="col" className="col-md-1 text-center align-self-center">ID</th>
                                    <th scope="col" className="col-md-1 text-center align-self-center">Approving Hei Id</th>
                                    <th scope="col" className="col-md-1 text-center align-self-center">Conditions Hash</th>
                                    <th scope="col" className="col-md-1 text-center align-self-center">IIIA ID</th>
                                    <th scope="col" className="col-md-1 text-center align-self-center">Date Created</th>
                                </tr>
                            </thead>
                            <tbody>
                                {approvals.map((approval, idx) => (
                                    <tr key={'approval-respones' + approval.id + idx}>
                                        <td key={"ID_" + idx} className="text-center align-self-center" data-title="No">{approval?.id ?? '-'}</td>
                                        <td key={"Approving_Hei_Id_" + idx} className="text-center align-self-center" data-title="Type">{approval?.approvingHeiId ?? '-'}</td>
                                        <td key={"Conditions_Hash_" + idx} className="text-center align-self-center" data-title="Hei ID">{approval?.conditionsHash ?? '-'}</td>
                                        <td key={"Iia_Id" + idx} className="text-center align-self-center" data-title="Notifier Hei ID">{approval?.iiaId ?? '-'}</td>
                                        <td key={"Date_Created_" + idx} className="text-center align-self-center" data-title="Date Created">{approval.dateCreated ?
                                            (approval.dateCreated.getDate() + "-" + (approval.dateCreated.getMonth() + 1) + "-" + approval.dateCreated.getFullYear() + " " + approval.dateCreated.getHours() + ":" + approval.dateCreated.getSeconds())
                                            : "-"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    :
                    (fetched && approvals.length == 0) ?
                        <div className="d-flex justify-content-center">
                            <p>Approval responses for this Inter-Institutional Agreement were not found</p>
                        </div>
                        : <div className="d-flex justify-content-center">
                            <Loader
                                className="spinner mx-auto"
                                type="TailSpin"
                                color="#3A435E"
                                height={70}
                                width={70}
                            />
                        </div>
            }
        </div>
    );
}

export default MobilityAgreementApprovalResponse;